import { jsx } from "react/jsx-runtime";
import { st, classes } from "./CoreDropdownOption.st.css";
const CoreDropdownOption = (props) => {
  const {
    id,
    option,
    isSelected,
    isHovered,
    role,
    onClickHandler,
    onMouseEnterHandler,
    onMouseLeaveHandler,
    dataHook
  } = props;
  const disabled = option.isDisabled;
  const selectable = option.isSelectable;
  const hovered = !disabled && isHovered;
  const selected = !disabled && isSelected;
  const ariaProps = selectable ? { role, "aria-selected": selected, "aria-disabled": disabled } : {};
  return /* @__PURE__ */ jsx(
    "div",
    {
      id,
      tabIndex: -1,
      className: st(
        classes.root,
        { disabled, selectable, hovered, selected },
        props.className
      ),
      "data-hook": dataHook,
      ...ariaProps,
      onClick: onClickHandler,
      title: option.value,
      onMouseEnter: onMouseEnterHandler,
      onMouseLeave: onMouseLeaveHandler,
      children: option.render(option.value)
    }
  );
};
CoreDropdownOption.displayName = "CoreDropdownOption";
export {
  CoreDropdownOption
};
//# sourceMappingURL=CoreDropdownOption.js.map
